var Price_Slider = {
	
}

$(window).load(function(){
	
})